/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './PerformanceCharts.scss';

import { array } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ProductTypePerformanceChart from './ProductTypePerformanceChart';
import { getGraphPerformanceData } from 'state/performance/ProductPerformanceSelectors';
import { getFilteredPerformancePeriods } from 'state/account/AccountPerformanceSelectors';

const PerformanceCharts = ({ productPerformance, performancePeriods }) => (
  <div className="performance-charts">
    <ProductTypePerformanceChart
      productPerformance={productPerformance}
      performancePeriods={performancePeriods}
    />
  </div>
);

PerformanceCharts.propTypes = {
  productPerformance: array.isRequired,
  performancePeriods: array.isRequired
};

const mapStateToProps = (state) => ({
  productPerformance: getGraphPerformanceData(state),
  performancePeriods: getFilteredPerformancePeriods(state)
});

export default connect(mapStateToProps)(PerformanceCharts);
